import { Component, ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    selector: 'checkout-suitability-disclaimer',
    templateUrl: './checkout-suitability-disclaimer.component.html',
    styleUrls: ['checkout-suitability-disclaimer.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CheckoutSuitabilityDisclaimerComponent {

    @Input('suitability') public suitability: string;
    @Output('riskAgreementAccepted') public riskAgreementAccepted: EventEmitter<boolean> = new EventEmitter();
    
    public riskAgreementChecked = false;
    public form: FormGroup;

    public constructor(private formBuilder: FormBuilder) {
        this.createManualForm();
    }

    public createManualForm() {
        this.form = this.formBuilder.group({ riskAgreementChecked: false });

        this.form.get('riskAgreementChecked').valueChanges
            .subscribe( value => this.riskAgreementAccepted.emit(value));
    }
}